/**
 * Date-extensions locale Croatian [hr]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('hr', {
    monthNames: ['Siječanj','Veljača','Ožujak','Travanj','Svibanj','Lipanj','Srpanj','Kolovoz','Rujan','Listopad','Studeni','Prosinac'],
    monthShortNames: ['Sij.','Velj.','Ožu.','Tra.','Svi.','Lip.','Srp.','Kol.','Ruj.','Lis.','Stu.','Pro.'],
    dayNames: ['Nedjelja','Ponedjeljak','Utorak','Srijeda','četvrtak','Petak','Subota'],
    dayShortNames: ['Ned.','Pon.','Uto.','Sri.','čet.','Pet.','Sub.']
});
